
export enum UserRole {
    Admin = "admin",
    Accounter = "accounter",
    Merchant = "merchant"
}


export default class LoginResponseModel {
    createdAt?: Date;
    updatedAt?: Date;
    id?: string;
    username?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    birthDay?: Date;
    address?: string;
    phone?: string;
    role?: UserRole;
    description?: string;
    money?: number;
    merchantProvider?: string;
    accessToken?: AccessToken;
    enable2FA?: boolean;

    isAdmin(): boolean {
        return this.role === UserRole.Admin;
    }

    isAccountant(): boolean {
        return this.role === UserRole.Accounter;
    }

    isMerchant(): boolean {
        return this.role === UserRole.Merchant;
    }
}


export class AccessToken {
    id?: string;
    ttl?: number;
    created?: Date;
    expired?: number;
}
